export const ADDITIONAL_DOCUMENTS_EVENTS = {
  VIEW_KYC_ADDITIONAL_DOCUMENTS_UTILITY_BILL:
    'view_kyc_additional_documents_utility_bill',
  UPLOAD_KYC_ADDITIONAL_DOCUMENTS_UTILITY_BILL:
    'upload_kyc_additional_documents_utility_bill',
  ERROR_KYC_ADDITIONAL_DOCUMENTS_UTILITY_BILL:
    'error_kyc_additional_documents_utility_bill',
  API_ERROR_KYC_ADDITIONAL_DOCUMENTS_UTILITY_BILL:
    'api_error_kyc_additional_documents_utility_bill',
  SELECT_KYC_ADDITIONAL_DOCUMENTS_UTILITY_BILL_CONTINUE:
    'select_kyc_additional_documents_utility_bill_continue',
  VIEW_KYC_ADDITIONAL_DOCUMENTS_PHONE_BILL:
    'view_kyc_additional_documents_phone_bill',
  UPLOAD_KYC_ADDITIONAL_DOCUMENTS_PHONE_BILL:
    'upload_kyc_additional_documents_phone_bill',
  ERROR_KYC_ADDITIONAL_DOCUMENTS_PHONE_BILL:
    'error_kyc_additional_documents_phone_bill',
  API_ERROR_KYC_ADDITIONAL_DOCUMENTS_PHONE_BILL:
    'api_error_kyc_additional_documents_phone_bill',
  SELECT_KYC_ADDITIONAL_DOCUMENTS_PHONE_BILL_CONTINUE:
    'select_kyc_additional_documents_phone_bill_continue',
} as const;
